export default __webpack_public_path__ + "static/media/project.94e7edf8.png";